module.exports = "<section class=\"container-fluid with-maxwidth chapter\">\n  <app-polizas-editar-view></app-polizas-editar-view>\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Contabilidad/polizas/polizas-editar/polizas-editar.component.html
// module id = ./src/app/Contabilidad/polizas/polizas-editar/polizas-editar.component.html
// module chunks = main